import React, { Component } from 'react';
import { adminservice } from '../../../services/admin.service';
import { tarbookService } from '../../../services/tarbook.service';

class DeleteshipDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectIdToDelete:0,
            showErrorMessage:false,
            showSucessMessage:false,
        };
    }

    componentDidMount=()=>{
        this.setState({
            selectIdToDelete:this.props.selectIdToDelete,
        })
    }

    deleteQuestion=async()=>{
        const{selectIdToDelete}=this.state;
            var response = await tarbookService.DeleteSelectedShipBoardDetails(selectIdToDelete);
            if(response.status === 200){
                this.props.GetShipBoardDetails();
                this.props.closeModel()
                // if(response.data == true){
                //     this.setState({
                //         showSucessMessage:true,
                //     },async()=>{
                //         this.props.GetShipBoardDetails();
                //     })
                // }
            }else{
                this.setState({
                    showErrorMessage:true,
                })
            }
    }

    onCancelClick=()=>{
        this.setState({
            showSucessMessage:false,
            showErrorMessage:false,
        })
        this.props.closeModel();
    }
    render() {
        const{
            showErrorMessage,
            showSucessMessage,
        }=this.state;
        return (
            <div className="modal update-unit-popup" id="myModal1">
                <div className="modal-dialog modal-dialog-centered modal-dialog-md">
                    <div className="modal-content">
                    {/* Modal Header */}
                    <div className="modal-header">
                        <h4 className="modal-title">Delete Ship board details</h4>
                        <button type="button" className="btn-close" onClick={()=>this.onCancelClick()}>X</button>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body" style={{overflowX: 'auto', padding: '30px'}}>
                        <h5 style={{fontWeight: 400, fontSize: '22px'}}>Are you sure you want to delete this ship detail?</h5>
                        {showErrorMessage && (
                                <small
                                id="emailHelp"
                                className="form-text"
                                style={{ color: "red" }}
                                >
                                Erro while deleting file
                                </small>
                        )}
                        {showSucessMessage && (
                            <div id="thank_you" className="alert alert-success" style={{ fontSize: '15px'}}>
                                Success! Ship Board Detail has been deleted
                                <button type="button" className="btn-close" data-bs-dismiss="alert" />
                            </div>
                        )}
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer">
                        <button type="button" className="btn Submit-btn" style={{padding:'7px 30px'}} onClick={()=>this.deleteQuestion()}>OK</button>
                        <button type="button" className="btn Cancel-btn" onClick={()=>this.onCancelClick()}>CANCEL</button>
                    </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteshipDetails;